import React from 'react';

import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TTableFilter } from '@interfaces/components/table';

import { MIN_FILTER_WIDTH } from '@constants/common';

export const getAlarmFilterValues = (selectedGeneratedFilters: Record<string, TSelectOption>) => {
	return Object.entries(selectedGeneratedFilters).reduce<Record<string, any>>((acc, [key, option]) => {
		const filter = option?.value !== undefined ? { [key]: option.value } : null;

		return filter
			? { ...acc, ...filter }
			: acc;
	}, {});
};

export const generateAlarmsFilters = (
	options: IAlarmFilter[],
	selectedFilters: Record<string, TSelectOption>,
	setSelectedGeneratedFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>,
): TTableFilter[] => {
	return options.map((filter) => {
		return {
			name: filter.name,
			placeholder: filter.placeholder,
			option: selectedFilters[filter.name] || null,
			options: filter.data,
			minWidth: MIN_FILTER_WIDTH,
			setState: (option: TSelectOption<string>) => {
				setSelectedGeneratedFilters((prev) => {
					if (option?.name) {
						return {
							...prev,
							[filter.name]: option,
						};
					}

					return {
						...prev,
						[filter.name]: null,
					};
				});
			},
			defaultValue: null,
		};
	});
};

